import { useShiftEditor } from '../useShiftEditor'
import { useCompanyLocation } from 'hooks/useCompanyLocation'
import { useLocationCoordinates } from 'hooks/useLocationCoordinates'
import { Map } from 'components/Map'
import { Heading, Text } from 'ui'
import { AddressString } from 'components/AddressString'
import { MapPinned } from 'lucide-react'
import styled from 'styled-components'
import { PreviewCard, PreviewInset, previewTokens } from './styles'

const previewMapOptions: google.maps.MapOptions = {
  clickableIcons: false,
  disableDefaultUI: true,
  gestureHandling: 'none',
  keyboardShortcuts: false,
}

const PreviewMap = styled(Map)`
  border-radius: ${previewTokens.radii.inner};
  overflow: hidden;
`

const AddressInset = styled(PreviewInset)`
  box-sizing: border-box;
  min-height: 52px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  padding: 10px 12px;
`

const AddressIcon = styled(MapPinned)`
  flex-shrink: 0;
  color: ${previewTokens.colors.muted};
`

const AddressText = styled(Text)`
  min-width: 0;
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  overflow-wrap: anywhere;
`

export function LocationMap() {
  const { shiftData } = useShiftEditor()
  const location = useCompanyLocation(shiftData?.details?.locationId)
  const coordinates = useLocationCoordinates(location)

  if (shiftData.details?.locationless || !coordinates) return null

  return (
    <PreviewCard>
      <Heading level={4} my={0} mb={2}>
        How to get there
      </Heading>
      <PreviewMap
        height={144}
        center={coordinates}
        zoom={11}
        mapOptions={previewMapOptions}
        markers={[
          {
            position: coordinates,
            title: location?.name ?? 'Selected Location',
          },
        ]}
      />
      {location?.address ? (
        <AddressInset>
          <AddressIcon size={17} aria-hidden="true" />
          <AddressText>
            <AddressString address={location.address} />
          </AddressText>
        </AddressInset>
      ) : null}
    </PreviewCard>
  )
}
